export default {
  newTag: {
    id: 'product_page_reassurance_item_new_tag',
    defaultMessage: 'New',
  },
}
